import React from 'react'
import { Link } from "react-router-dom"
import { wharfEventLink } from '../Shared/Links'
// import PDF__Link from '../../PDF__FILE.pdf'
// import DownIcon from '@mui/icons-material/KeyboardArrowDown'

export default function NavItems(props){
  return(
    <ul className={`megamenu-parent menu-zoom hidden-xs ${props.where ?? 'uni'} ${props.addClass ?? 'std'}`}>
      <li className="menu-item"><Link to="/">Home</Link></li>
      <li className="menu-item has-child"><Link to="#" className="mom">Menus</Link>
        <div className="dropdown">
          <div className="dropdown-inner">
            <ul className="dropdown-items">
              <li className="menu-item"><Link to="/daily-menu">Lunch</Link></li>
              <li className="menu-item"><Link to="/dinner-menu">Dinner</Link></li>
              <li className="menu-item"><Link to="/brunch-menu">Brunch</Link></li>
              <li className="menu-item"><Link to="/happy-hour">Happy Hour</Link></li>
              <li className="menu-item"><Link to="/drink-menu">Drink Menu</Link></li>
              <li className="menu-item"><Link to="/#family-meals">Family Meals</Link></li>
            </ul>
          </div>
        </div>
      </li>
      {/* <li className="menu-item"><Link to="/happy-hour">Specials</Link></li> */}
      <li className="menu-item sig"><Link to="/events">Holiday Events + Deals</Link></li>
      {/* <li className="menu-item has-child"><Link to="#" className="mom">Events</Link>
        <div className="dropdown">
          <div className="dropdown-inner">
            <ul className="dropdown-items">
              <li className="menu-item"><Link to={holidayEvents} target="_blank" rel="noreferrer">Holiday Season</Link></li>
              <li className="menu-item"><Link to="/pairing">Wine Pairings</Link></li>
              <li className="menu-item"><Link to="/thanksgiving">Thanksgiving</Link></li>
            </ul>
          </div>
        </div>
      </li> */}

      <li className="menu-item"><a href="https://wharfcateringgroup.com/" target="_blank" rel="noreferrer">Catering</a></li>

      <li className="menu-item has-child"><Link to="#" className="mom">More</Link>
        <div className="dropdown">
          <div className="dropdown-inner">
            <ul className="dropdown-items">
              <li className="menu-item"><Link to="/about">About</Link></li>
              <li className="menu-item"><Link to="/contact">Contact</Link></li>
              <li className="menu-item"><a href={wharfEventLink} target="_blank" rel="noreferrer">Events At The Wharf</a></li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  )
}